import { axios } from 'libs';

const resource = '/tributos';

export const integracaoComTributosEstaValida = () => {
  return axios.get(`${resource}/integracao/valida`);
};

export const integracaoComTributosEstaAtivada = () => {
  return axios.get(`${resource}/integracao/ativada`);
};

export function integraPessoaAiseProcesso(processo) {
  return axios.post(`${resource}/${processo.id}`);
}

export const getRequerimento = (entidade, exercicio, requerimento) => {
  return axios.get(
    `${resource}/requerimentos/${entidade}/${exercicio}/${requerimento}`
  );
};
